import { assertsNotNull } from "@formant/core/common/defined";

export function assertHasPeerConnection(
    it: RTCPeerConnection | null,
): asserts it is RTCPeerConnection {
    assertsNotNull(it, "RTCPeerConnection is closed!");
}
